import React, { useState } from "react";

import DashboardsList from "../DashboardsList/DashboardsList";
import CustomerListContainer from "../../containers/CustomerListContainer/CustomerListContainer";
import { Box, IconButton, Tooltip, useMediaQuery, useTheme } from "@mui/material";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { useSelectedSystems } from '../../hooks/useCloudSelectors';

const SIDEBAR_VISIBLE_STORAGE_KEY = "customerDevicesView.showSidebar";

const CustomerDevicesView = () => {
  const theme = useTheme();

  const selectedSystems = useSelectedSystems();

  const [showSidebar, setShowSidebar] = useState(() => {
    const stored = localStorage.getItem(SIDEBAR_VISIBLE_STORAGE_KEY);
    return stored !== null ? stored === "true" : true;
  });

  const toggleSidebar = () => {
    setShowSidebar((prev) => {
      const next = !prev;
      localStorage.setItem(SIDEBAR_VISIBLE_STORAGE_KEY, String(next));
      return next;
    });
  };

  const isMobile = useMediaQuery(theme.breakpoints.down("lg"));

  return (
    <Box
      sx={{
        height: "100%",
        width: "100%",
        display: "flex",
        borderTop: `1px solid ${theme.palette.primary.dark}`,
        overflow: "none",
        backgroundColor: theme.palette.background.paper
      }}
    >
      {!isMobile && (
        <>
          {showSidebar && (
            <Box
              sx={{
                backgroundColor: theme.palette.background.paper,
                overflowY: "auto",
                borderRight: `1px solid ${theme.palette.primary.dark}`,
                maxWidth: { lg: "350px", xl: "370px", xxl: "400px" },
              }}
            >
              <CustomerListContainer selectedSystems={selectedSystems} />
            </Box>
          )}
          <Tooltip title={showSidebar ? "Hide sites" : "Show sites"} placement="right">
            <IconButton
              onClick={toggleSidebar}
              size="small"
              sx={{
                alignSelf: "flex-start",
                flexShrink: 0,
                marginTop: 1,
                width: 24,
                height: 48,
                borderRadius: "0 4px 4px 0",
                border: `1px solid ${theme.palette.primary.dark}`,
                borderLeft: "none",
              }}
            >
              {showSidebar ? <ChevronLeftIcon fontSize="small" /> : <ChevronRightIcon fontSize="small" />}
            </IconButton>
          </Tooltip>
        </>
      )}
      <Box sx={{ flex: 3, overflowY: showSidebar ? "auto" : "hidden" }}>
        <DashboardsList showSidebar={showSidebar} />
      </Box>
    </Box>
  );
};

export default CustomerDevicesView;
